<template>
  <div v-editable="blok" class="author-card">
    <BaseNuxtImage
      class="fluid-image author-card__portrait"
      :src="(blok.portrait && blok.portrait.filename) || '/'"
      :alt="(blok.portrait && blok.portrait.alt) || `Portrait of ${blok.name}`"
      loading="lazy"
    />
    <div class="author-card__description">
      <p class="author-card__name">
        {{ blok.name }}
      </p>
      <p class="author-card__role">
        {{ blok.role }}
      </p>
      <a
        :href="blok.linkedin_link"
        target="_blank"
        class="author-card__link author-card__link--linkedin"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbCardAuthorStoryblok } from '@/types'
interface Props {
  blok: SbCardAuthorStoryblok
}
defineProps<Props>()
</script>

<style lang="scss" scoped>
.author-card {
  display: flex;
  align-items: flex-start;
  margin-bottom: 48px;

  @media (min-width: $breakpoint-md) {
    flex-direction: column;
    width: 206px;
    margin-bottom: 0;
    margin-right: 20px;
  }

  @media (min-width: $breakpoint-lg) {
    width: 235px;
    margin-right: 105px;
  }

  &__portrait {
    width: 112px;
    height: 112px;
    margin-right: 6px;
    border-radius: 50%;

    @media (min-width: $breakpoint-md) {
      width: 128px;
      height: 128px;
      margin-right: 0;
      margin-bottom: 26px;
    }
  }

  &__name {
    margin-bottom: 8px;
    font-size: var(--font-size-paragraph-m);
    font-weight: var(--font-weight-paragraph-bold);
    color: var(--cobalt-800);
  }

  &__role {
    margin-bottom: 14px;
    font-size: var(--font-size-paragraph-s);
    font-weight: 400;
    color: var(--navy-700);
  }

  &__link {
    display: block;
    width: 20px;
    height: 20px;

    &--linkedin {
      background-image: url('@/assets/icons/20-ico-linkedin.svg');
    }
  }
}
</style>
